import httpRequest from '@/utils/request'

// 出入库详情
export function getList(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/findById',
        method: 'get',
        params
    })
}

// 出库/入库扫描篮筐码 - H5
export function outScanAppliances(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/outScanAppliances',
        method: 'get',
        params
    })
}

// 根据转库单获取出库信息 - H5
export function getOutByWTransferId(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/getOutByWTransferId',
        method: 'get',
        params
    })
}

// 出库单保存
export function saveOut(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/saveOut',
        method: 'post',
        data
    })
}

// 入库单保存
export function saveIn(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/saveIn',
        method: 'post',
        data
    })
}

// 根据转库单获取入库信息
export function getInByWTransferId(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/getInByWTransferId',
        method: 'get',
        params
    })
}

// 根据ID查询货位信息
export function getLocationInfo(id: string | number): Promise<any> {
    return httpRequest({
        url: `ext/warehouseLocationExt/${id}`,
        method: 'get'
    })
}

// 根据ID查询货位信息
export function finishedInBill(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/finishedInBill',
        method: 'get',
        params
    })
}

// 获取转库单信息
export function wTransferForInOut(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wTransferExt/wTransferForInOut',
        method: 'get',
        params
    })
}

// 获取出入库单信息
export function wOutBoundForInOut(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/wOutBoundForInOut',
        method: 'get',
        params
    })
}

// 获取转库单信息
export function saveOutCK(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/saveOut',
        method: 'post',
        data
    })
}

// 提交转库单出入库
export function wTransferForInOutUpload(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wTransferExt/wTransferForInOutUpload',
        method: 'get',
        params
    })
}

// 调整入库
// export function wOutBoundForStockUp(data: any): Promise<any> {
//     return httpRequest({
//         url: 'ext/wOutboundExt/wOutBoundForStockUp',
//         method: 'post',
//         data
//     })
// }

// 调整入库
export function wOutBoundForStockUp(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/createForStandard',
        method: 'post',
        data
    })
}

// 出入库业务处理提交
export function wOutBoundForUpload(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/wOutboundExt/wOutBoundForUpload',
        method: 'get',
        params
    })
}

// 物料分配信息分页查询
export function materialDistributeExt(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/materialDistributeExt/page',
        method: 'post',
        data
    })
}

// 根据物料主键查询物料分配数据
export function getMaterialItem(params: any): Promise<any> {
    return httpRequest({
        url: `ext/materialDistributeExt/findByMaterialId`,
        method: 'get',
        params
    })
}

// 根据物料分配主键查询
export function getListByMaterialId(params: any): Promise<any> {
    return httpRequest({
        url: 'ext/proceduresExt/getListByMaterialId',
        method: 'get',
        params
    })
}

// 根据转库单查询库存
export function choiceStockPageByTransfer(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wStockExt/choiceStockPageByTransfer',
        method: 'post',
        data
    })
}

// 转库出库业务 - H5
export function transferToOutNew(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/wTransferExt/transferToOutNew',
        method: 'post',
        data
    })
}

// 转库入库业务 - H5
export function transferToInNew(data: any): Promise<any> {
    return httpRequest({
        url:  '/ext/wTransferExt/transferToInNew',
        method: 'post',
        data
    })
}

// 根据供需计划查询可用库存
export function getStockByPlansForStandard(data: any): Promise<any> {
    return httpRequest({
        url:  '/ext/workorderRecordExt/getStockByPlansForStandard',
        method: 'post',
        data
    })
}